export function getRandomSeedFromHour() {
  return new Date(Date.now()).getUTCHours();
}
